__webpack_require__.p = "/_vista/static/chunks/";